import { render } from "./SearchRefinedTagList.vue?vue&type=template&id=0cb77449&ts=true"
import script from "./SearchRefinedTagList.vue?vue&type=script&lang=ts"
export * from "./SearchRefinedTagList.vue?vue&type=script&lang=ts"

import "./SearchRefinedTagList.vue?vue&type=style&index=0&id=0cb77449&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__